export default __webpack_public_path__ + "static/media/uiux.b70808d9.svg";